// extracted by mini-css-extract-plugin
module.exports = {"root":"ProjectTag_root__7P8ZY","name":"ProjectTag_name__IS0lW","fontsizing":"ProjectTag_fontsizing__3QHN0"};